import { render, staticRenderFns } from "./Link.vue?vue&type=template&id=47bddc91"
import script from "./Link.vue?vue&type=script&lang=js"
export * from "./Link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47bddc91')) {
      api.createRecord('47bddc91', component.options)
    } else {
      api.reload('47bddc91', component.options)
    }
    module.hot.accept("./Link.vue?vue&type=template&id=47bddc91", function () {
      api.rerender('47bddc91', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/TopMenu/Link.vue"
export default component.exports